module.exports = __webpack_public_path__ + "img/video-thumb-3-nl.611f331c.png";